import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "create-ticket-footer" }
const _hoisted_2 = { class: "create-ticket-footer__buttons" }

import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { CreateTicket } from '@/services/tickets.service'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'

interface EMITS {
  (e: 'cancelCreateTicket'): void
  (e: 'createTicket'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTicketFooter',
  emits: ["cancelCreateTicket", "createTicket"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const { t } = useI18n()

const formData = inject<CreateTicket>('formDataCreateErrand')

const disableSaveButton = computed(() => {
  return (
    !formData?.title.length ||
    !formData?.typeId ||
    !formData?.categoryId ||
    !formData?.status ||
    !formData?.priority
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(ButtonOutline, {
        buttonText: _unref(t)('general__text__cancel'),
        onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (emits('cancelCreateTicket')))
      }, null, 8, ["buttonText"]),
      _createVNode(ButtonPrimary, {
        buttonText: `${_unref(t)('general__data__create')} ${_unref(t)(
          'general__data__ticket-the'
        ).toLowerCase()}`,
        disabled: disableSaveButton.value,
        onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('createTicket')))
      }, null, 8, ["buttonText", "disabled"])
    ])
  ]))
}
}

})